import Vue from 'vue'
import { NoticeBar } from 'vant'
Vue.use(NoticeBar)
